<template lang="pug">
StandardChart(
  :input="chartData",
  chartType="bar",
  stacked,
  legend,
  max-width="100%",
  :loading="loading"
)
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      organization: null, // ID of the organization
      loading: false,
      results: [],
      colors: ["#7682d6", "#2cb2b9", "#50a948", "#ad4d24", "#a74ac3"],
    };
  },
  computed: {
    chartData() {
      // stack results by month, fill in missing months
      // months = array of month numbers
      // label with [Jan, Feb, Mar, ...]
      const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      const labels = months.map((month) => {
        const date = new Date(this.year, month - 1);
        return date.toLocaleString("default", { month: "short" });
      });
      // unique types and sort by name
      const types = Array.from(
        new Set(this.results.map((result) => result.type))
      ).sort();
      // fill in missing months and group by type and fill in missing types
      let results = months.map((month) => {
        return types.map((type) => {
          const count = this.results
            .filter((result) => result.month === month && result.type === type)
            .reduce((a, b) => a + b.count, 0);
          return { type, count };
        });
      });

      // map to chart data
      const datasets = types.map((type, index) => {
        return {
          label: type,
          backgroundColor: this.colors[index % this.colors.length],
          data: results.map((result) => result[index].count),
          stack: "Stack 0",
        };
      });
      return { title: `${this.year} Lead Growth`, labels, datasets };
    },
  },
  methods: {
    async load({ year, organization }) {
      this.loading = true;
      if (year) this.year = year;
      this.organization = organization;
      const params = { year: this.year, organization: this.organization };
      try {
        this.results = await this.$api.crm.lead.custom("yearly", params);
      } catch (e) {
        console.log(e?.response?.data);
      }
      this.loading = false;
    },
  },
};
</script>